import { setAccessTokenProvider } from './apiClient';

/**
 * Eigene Authentifizierung (ADR 0012): Access-Token (JWT) aus dem Login-Flow
 * (Passwort + TOTP-2FA) im localStorage; der apiClient hängt es an jede Anfrage.
 */
const TOKEN_KEY = 'proerp.accessToken';

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function storeToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

/** Beim App-Start einhängen — liefert ab dann das gespeicherte Token. */
export function initAuth(): void {
  setAccessTokenProvider(async () => getStoredToken());
}

export function logout(): void {
  clearToken();
  window.location.assign('/');
}

/** Freundlicher Geräte-Anzeigename für einen neu registrierten Passkey (ADR 0034). */
export function guessDeviceLabel(): string {
  const ua = navigator.userAgent;
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua)) return 'iPad';
  if (/Macintosh/.test(ua)) return 'Mac';
  if (/Android/.test(ua)) return 'Android-Gerät';
  if (/Windows/.test(ua)) return 'Windows-PC';
  return 'Mein Gerät';
}
